<template>
  <div class="p-d-flex p-flex-column">
    <span>{{ __("Unit") }}:</span>
    <p-vue-dropdown
      :options="UnitsOptions"
      :optionLabel="'Number'"
      :filter="UnitsOptions.length > 10"
      v-model="unit"
      class="dropdown"
      id="UID"
    >
      <template #value="{ value, placeholder}">
        <div class="inner p-d-flex p-jc-between">
          <span class="value">{{ value ? value.Number : placeholder }}</span>
          <span class="icon">
            <i-icon name="arrow" />
          </span>
        </div>
      </template>
    </p-vue-dropdown>
    <i-form-error :data="errors.unit" />
  </div>
  <div class="p-d-flex p-flex-column p-pt-4">
    <span>{{ __("Sum") }}:</span>
    <p-vue-input-number v-model="sum" mode="decimal" :minFractionDigits="2" />
    <i-form-error :data="errors.sum" />
  </div>
  <div class="p-d-flex p-flex-column p-pt-4">
    <span>{{ __("billing reason") }}:</span>
    <p-vue-input-text v-model="subject" />
    <i-form-error :data="errors.subject" />
  </div>
  <div class="p-d-flex p-pt-4">
    <div class="p-d-flex">
      <p-vue-radio
        v-model="type"
        inputId="feesType_1"
        :value="13"
      ></p-vue-radio>
      <label class="p-mr-3" for="feesType_1">{{ __("special") }}</label>
    </div>
    <div class="p-d-flex p-mr-5">
      <p-vue-radio
        v-model="type"
        inputId="feesType_2"
        :value="14"
      ></p-vue-radio>
      <label class="p-mr-3" for="feesType_2">{{ __("Other") }}</label>
    </div>
  </div>
  <i-form-error :data="errors.type" />
  <div class="p-d-flex p-jc-between p-mt-4">
    <p-vue-button
      :class="{
        submit: true,
        'p-button': true,
        'p-button-lg': true,
        'p-button-success': true,
        'p-button-rounded': true,
      }"
      @click="close"
      icon
      :label="__('Cancel')"
    >
    </p-vue-button>
    <p-vue-button
      :class="{
        submit: true,
        'p-button': true,
        'p-button-lg': true,
        'p-button-success': true,
        'p-button-rounded': true,
      }"
      @click="submit"
      :loading="btnLoading"
      icon
      :label="__('Send')"
    >
    </p-vue-button>
  </div>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import { errorReceived } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import { showSuccessOrFailedModal } from "../../services/apointUtil";
import { ValidationError } from "vue3-form-validation";
export default {
  plugins: { __ },
  props: {
    BID: {
      type: Number,
    },
    close: Function,
  },
  data() {
    return {
      UnitsOptions: [],
      unit: null,
      type: null,
      subject: null,
      sum: null,
      errors: {},
      btnLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("BID", this.BID, apiPType.Int)];
      callProc("WorkerApp_AddMeterData", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.$store.dispatch("doLoading", false);
          this.UnitsOptions = result.Table;
        })
        .catch(() => {
          errorReceived("WorkerApp_AddMeterData");
        });
    },
    validateFields() {
      this.valid = true;
      this.errors = {};

      if (!this.unit) {
        this.valid = false;
        this.errors.unit = __("Required field");
      }
      if (!this.sum) {
        this.valid = false;
        this.errors.sum = __("Required field");
      }
      if (!this.subject) {
        this.valid = false;
        this.errors.subject = __("Required field");
      }
      if (!this.type) {
        this.valid = false;
        this.errors.type = __("Required field");
      }
    },
    submit() {
      try {
        this.validateFields();
        if (this.valid) {
          this.$store.dispatch("doLoading", true);
          this.btnLoading = true;
          let procParams = [
            apiParam("UID", this.unit.UID, apiPType.Int),
            apiParam("Description", this.subject, apiPType.NVarChar),
            apiParam("Amount", this.sum, apiPType.Float),
            apiParam("UFIType", this.type, apiPType.Int),
          ];
          callProc("App_AddFeesToUnit", procParams)
            .then((result) => {
              result = JSON.parse(result);
              this.btnLoading = false;
              this.$store.dispatch("doLoading", false);
              if (result.procReturnValue == 0) {
                showSuccessOrFailedModal(
                  __("The charge has been saved successfully")
                );
                this.close();
              }
            })
            .catch(() => {
              this.btnLoading = false;
              errorReceived("App_AddFeesToUnit");
            });
        }
      } catch (err) {
        if (!(err instanceof ValidationError)) console.error(err);
      }
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.p-dropdown {
  width: 100%;
}

:deep(.svg) {
  color: var(--color-success);
  width: 18px;
  height: 18px;
}

.sms-to {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 15px 0;
}

.sms-to-checkbox {
  display: flex;
  align-items: center;
  gap: 7px;
}

.p-inputtextarea {
  width: 100%;
}
</style>
